

































import LLoading from "@/components/Common/LLoading.vue";
import { defineProps, withDefaults, defineEmits } from "@vue/runtime-dom";
import { computed, watch, onBeforeUnmount, reactive } from "@vue/composition-api";
import { useModal } from "@/components/Common/Modals/composables/useModal";
interface Props {
  autocomplete?: boolean;
  fullScreen?: boolean;
  width?: number | string;
  customClass?: string;
  isLoading?: boolean;
  isActive?: boolean;
  onCancel?: () => void;
  canCancel?: ["escape", "x", "outside"];
}
interface Emits {
  created: [];
  cancel: [];
  confirm: [];
  "update:isActive": [value: boolean];
  opened: [];
  closed: [];
  update: [];
  beforeDestroy: [];
}
const __sfc_main = {};
__sfc_main.props = {
  autocomplete: {
    key: "autocomplete",
    required: false,
    type: Boolean,
    default: false
  },
  fullScreen: {
    key: "fullScreen",
    required: false,
    type: Boolean,
    default: false
  },
  width: {
    key: "width",
    required: false,
    type: [Number, String],
    default: 960
  },
  customClass: {
    key: "customClass",
    required: false,
    type: String,
    default: null
  },
  isLoading: {
    key: "isLoading",
    required: false,
    type: Boolean,
    default: false
  },
  isActive: {
    key: "isActive",
    required: false,
    type: Boolean,
    default: false
  },
  onCancel: {
    key: "onCancel",
    required: false,
    type: Function,
    default: null
  },
  canCancel: {
    key: "canCancel",
    required: false,
    type: Array,
    default: () => ["escape", "x", "outside"]
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    isModalActive
  } = useModal(props, emit);
  const savedScroll = reactive({
    x: 0,
    y: 0
  });
  const onCancelAction = computed(() => props.onCancel ? props.onCancel : () => {});
  emit("created");
  setScrollAfterClose(true);
  function setScrollAfterClose(value: boolean) {
    if (value) {
      savedScroll.x = window.scrollX || document.documentElement.scrollLeft;
      savedScroll.y = window.scrollY || document.documentElement.scrollTop;
    } else {
      setTimeout(() => {
        window.scrollTo(savedScroll.x, savedScroll.y);
        savedScroll.x = savedScroll.y = 0;
      }, 0);
    }
  }
  watch(isModalActive, setScrollAfterClose);
  onBeforeUnmount(() => {
    setScrollAfterClose(false);
    emit("beforeDestroy");
  });
  return {
    isModalActive,
    onCancelAction
  };
};
__sfc_main.components = Object.assign({
  LLoading
}, __sfc_main.components);
export default __sfc_main;
